import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Calendar, Check, ArrowUpRight, Phone } from 'lucide-react';

// Square-hosted booking page. Update this single constant if the link ever changes.
export const SQUARE_BOOKING_URL =
  'https://app.squareup.com/appointments/book/0bttpggw0o7ueo/LR98ER1Z0X66E/start';

const SquareBookingCTA = () => {
  const { t } = useLanguage();
  const c = t.booking.squareCta;

  return (
    <div
      className="bg-[#25342C] text-[#F5F0E8] min-h-[560px] flex flex-col justify-center p-10 lg:p-14"
      data-testid="square-booking-cta"
    >
      <div className="flex items-center gap-3 mb-6">
        <Calendar size={18} className="text-[#a84b2a]" />
        <span className="eyebrow text-[#F5F0E8]/60 text-xs uppercase tracking-[0.25em]">
          {c.eyebrow}
        </span>
      </div>

      <h2 className="font-serif text-3xl lg:text-4xl font-light tracking-tight mb-5">
        {c.title}
      </h2>

      <p className="text-[#F5F0E8]/70 font-light leading-relaxed mb-8 max-w-md">
        {c.body}
      </p>

      <ul className="space-y-3 mb-10">
        {c.points.map((point) => (
          <li key={point} className="flex items-start gap-3 text-sm text-[#F5F0E8]/80 font-light">
            <Check size={16} className="text-[#a84b2a] mt-0.5 shrink-0" />
            {point}
          </li>
        ))}
      </ul>

      <a
        href={SQUARE_BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-3 bg-[#a84b2a] hover:bg-[#c05a35] transition-colors text-[#F5F0E8] text-sm uppercase tracking-[0.2em] px-8 py-5 w-full sm:w-auto"
        data-testid="square-booking-link"
      >
        {c.cta}
        <ArrowUpRight size={16} />
      </a>
      <p className="text-[10px] text-[#F5F0E8]/40 mt-3 uppercase tracking-[0.15em]">
        {c.opensNew}
      </p>

      <div className="mt-10 pt-8 border-t border-[#F5F0E8]/10 flex items-center gap-3 text-sm text-[#F5F0E8]/70">
        <Phone size={15} className="text-[#a84b2a]" />
        <span className="font-light">{c.phoneLabel}</span>
        <a
          href="tel:+15142272366"
          className="text-[#F5F0E8] hover:text-[#a84b2a] transition-colors font-medium"
          data-testid="square-booking-phone"
        >
          (514) 227-2366
        </a>
      </div>
    </div>
  );
};

export default SquareBookingCTA;
